import React from "react";
import { Combo } from "../../common/components/comboBox"
import { formGroup } from "../../common/components/formGroup";
import Store from "../ProvinceStore";

const Combobox = Combo<string>();
interface Props {
    value: string | null,
    onChange: (type: string | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
const __ProvinciaSelector = ({ onChange, value, error, label, onBlur, onFocus }: Props) => {

    const data = Store.useAll();
    return <Combobox
        label={label ?? "Provincia"}
        allowNull
        data={data ?? []}
        textField={x => x}
        onSelect={onChange}
        value={value}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
        busy={!data}
    />;
}
export default formGroup(__ProvinciaSelector);
